import React from 'react';

const Footer = props => {
	return (
		<div style={{marginTop: '20px'}}>
			Made with love by <a href="http://suyashkumar.com"> Suyash Kumar </a>
		</div>
	); 
}
export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/footer.js
 **/